import { useEffect } from 'react';
import type { StartupIssue } from '../lib/startupConfig';
import { hideNativeSplash } from '../lib/runtime';

export function ConfigErrorScreen({ issues }: { issues: StartupIssue[] }) {
  useEffect(() => {
    void hideNativeSplash();
  }, []);

  return (
    <div className="grain flex min-h-screen items-center justify-center px-6 py-10">
      <div className="cine-card w-full max-w-md p-8">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
          MovieMe
        </p>
        <h1
          className="mb-3 text-2xl font-semibold text-foreground"
          style={{ fontFamily: "'Fraunces', Georgia, serif" }}
        >
          This build is missing configuration
        </h1>
        <p className="mb-5 text-sm leading-relaxed text-muted-foreground">
          The app shell loaded, but required keys were not baked into this native
          bundle. Rebuild with the local <code>.env</code> present — do not submit
          this build.
        </p>
        <ul className="space-y-2 text-sm text-foreground">
          {issues.map((issue) => (
            <li key={issue.key}>
              <span className="font-mono text-xs text-primary">{issue.key}</span>
              <span className="block text-muted-foreground">{issue.message}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
